if (!customElements.get("gift-card-form")) {
  class GiftCardFormComponent extends HTMLElement {
    constructor() {
      super();

      this.mainElement = this.closest("add-to-cart-form");

      this.assistedEnabled = this.dataset.assisted === "true";
      this.mode = this.assistedEnabled ? "assisted" : "custom";

      this.deliverMode = "now";
      this.assistedMessageEl = this.querySelector("assisted-message");
      this.recipentNameEl = this.querySelector(".recipient-name");
      this.recipentEmailEl = this.querySelector(".recipient-email");
      this.personalizedMessageEl = this.querySelector(".personalized-message");
      this.assistBtnEl = this.querySelector(".btn-assist");
      this.deliverNowEl = this.querySelector(".btn-delivery.btn-now");
      this.deliverScheduleEl = this.querySelector(".btn-delivery.btn-schedule");
      this.sendAsGiftEl = this.querySelector(".send-as-gift");

      this.validationInputs = [];
      this.updateValidationInputs();

      this.initEvents();
      this.updateMode();
      this.updateDeliverMode();
    }
    updateMode() {
      if (this.assistedEnabled && this.mode === "assisted") {
        if (this.assistedMessageEl)
          this.assistedMessageEl.classList.remove("hide");
        this.personalizedMessageEl.closest(".gift-field").classList.add("hide");
      } else {
        if (this.assistedMessageEl)
          this.assistedMessageEl.classList.add("hide");
        this.personalizedMessageEl
          .closest(".gift-field")
          .classList.remove("hide");
      }
    }
    updateDeliverMode() {
      this.classList.remove("now", "schedule");
      this.classList.add(this.deliverMode);
      if (this.deliverMode === "schedule") {
        this.querySelector(".delivery-date").classList.add("required");
      } else {
        this.querySelector(".delivery-date").classList.remove("required");
      }
      this.updateValidationInputs();
      this.disableFormProperties();
      this.enableFormProperties();
      this.validateForm();
    }
    updateValidationInputs() {
      this.disableInputEvents();
      this.validationInputs = this.querySelectorAll(
        "input.required, textarea.required"
      );
      this.enableInputEvents();
      this.enableFormProperties();
    }
    initEvents() {
      if (this.assistedMessageEl) {
        this.assistedMessageEl.addEventListener(
          "assistedMessageUpdated",
          this.onAssistedMessageUpdated.bind(this)
        );
        this.assistedMessageEl.addEventListener(
          "writeCustomMessage",
          this.onWriteCustomMessage.bind(this)
        );
        this.assistBtnEl.addEventListener("click", this.onAssist.bind(this));
      }

      this.deliverNowEl.addEventListener("click", this.onDeliverNow.bind(this));
      this.deliverScheduleEl.addEventListener(
        "click",
        this.onDeliverSchedule.bind(this)
      );
      this.sendAsGiftEl.addEventListener(
        "change",
        this.onSendAsGift.bind(this)
      );
      // form validation
      this.validationInputs.forEach((validationInput) =>
        validationInput.addEventListener(
          "change",
          this.onInputChange.bind(this)
        )
      );
    }
    onInputChange(event) {
      this.validateForm();
    }
    validateForm() {
      if (!this.sendAsGiftEl.checked) return;

      var isValid = Array.from(this.validationInputs).reduce(
        (tot, validationInput) => {
          let validateField =
            validationInput.type === "email"
              ? $s.validateEmail(validationInput.value)
              : validationInput.value;
          return tot && validateField;
        },
        true
      );

      if (isValid) {
        this.mainElement.querySelector(".btn.add").disabled = false;
      } else {
        this.mainElement.querySelector(".btn.add").disabled = true;
      }
    }
    onSendAsGift(event) {
      if (event.target.checked) {
        this.querySelectorAll(".gift-field").forEach((giftFieldEl) =>
          giftFieldEl.classList.add("active")
        );
        this.enableFormProperties();
        this.validateForm();
      } else {
        this.querySelectorAll(".gift-field").forEach((giftFieldEl) =>
          giftFieldEl.classList.remove("active")
        );
        this.disableFormProperties();
        this.mainElement.querySelector(".btn.add").disabled = false;
      }
    }
    enableFormProperties() {
      if (!this.sendAsGiftEl.checked) return;
      this.querySelectorAll(".form-property.required").forEach(
        (formPropertyEl) =>
          (formPropertyEl.name = formPropertyEl.dataset.originalName)
      );
    }
    disableFormProperties() {
      this.querySelectorAll(".form-property").forEach(
        (formPropertyEl) => (formPropertyEl.name = "")
      );
    }
    enableInputEvents() {
      this.validationInputs.forEach((validationInput) => {
        validationInput.addEventListener(
          "change",
          this.onInputChange.bind(this)
        );
      });
    }
    disableInputEvents() {
      this.validationInputs.forEach((validationInput) => {
        validationInput.removeEventListener(
          "change",
          this.onInputChange.bind(this)
        );
      });
    }
    onAssist(event) {
      event.preventDefault();
      this.mode = "assisted";
      this.assistedMessageEl.reset();
      this.updateMode();
    }
    onWriteCustomMessage() {
      this.personalizedMessageEl.value = "";
      this.mode = "custom";
      this.updateMode();
    }
    onAssistedMessageUpdated(event) {
      this.personalizedMessageEl.value = event.detail.message;
      this.personalizedMessageEl.dispatchEvent(
        new Event("change", { bubbles: true })
      ); // needed for validation
    }
    onDeliverNow(event) {
      event.preventDefault();
      this.deliverMode = "now";
      this.deliverNowEl.classList.add("active");
      this.deliverScheduleEl.classList.remove("active");
      this.updateDeliverMode();
    }
    onDeliverSchedule(event) {
      event.preventDefault();
      this.deliverMode = "schedule";
      this.deliverNowEl.classList.remove("active");
      this.deliverScheduleEl.classList.add("active");
      this.updateDeliverMode();
    }
  }
  customElements.define("gift-card-form", GiftCardFormComponent);
}

if (!customElements.get("assisted-message-progress")) {
  class AssistedMessageProgressComponent extends HTMLElement {
    constructor() {
      super();
      this.assistedMessageEl = this.closest("assisted-message");
      this.stepButtonEls = this.querySelectorAll(".btn-progress");
      this.trackEl = this.querySelector(".progress-track");
      this.stepSize = 100 / (this.stepButtonEls.length - 1);
      this.setStep(1);
      this.initEvents();
    }
    initEvents() {
      this.assistedMessageEl.addEventListener(
        "stepsUpdated",
        this.onStepsUpdated.bind(this)
      );
      this.stepButtonEls.forEach((stepButtonEl) =>
        stepButtonEl.addEventListener("click", this.onStepSelected.bind(this))
      );
    }
    onStepSelected(event) {
      event.preventDefault();
      this.dispatchEvent(
        new CustomEvent("stepSelected", {
          detail: { stepId: parseInt(event.target.dataset.stepId) },
        })
      );
    }
    onStepsUpdated(event) {
      this.setStep(event.detail.stepId + 1);
    }
    setStep(stepId) {
      this.clearSteps();
      for (var i = 0; i < stepId; i++) {
        this.stepButtonEls[i].classList.add("active");
        this.stepButtonEls[i].disabled = false;
      }
      this.trackEl.style.width = `${this.stepSize * (stepId - 1)}%`;
    }
    clearSteps() {
      this.stepButtonEls.forEach((stepButtonEl) => {
        stepButtonEl.classList.remove("active");
        stepButtonEl.disabled = true;
      });
    }
  }
  customElements.define(
    "assisted-message-progress",
    AssistedMessageProgressComponent
  );
}

if (!customElements.get("assisted-message")) {
  class AssistedMessageComponent extends HTMLElement {
    constructor() {
      super();
      this.currentStep = 0;
      this.selectedMessages = [];
      this.editMode = true;
      this.preMessage = this.dataset.preMessage;
      this.messageStepEls = this.querySelectorAll("message-step");
      this.messageDisplayEl = this.querySelector(".message-display");
      this.progressBarEl = this.querySelector("assisted-message-progress");
      this.buttonsControlEl = this.querySelector(".buttons-control");
      this.defaultMessage = this.dataset.defaultMessage;
      this.categories = this.dataset.categories
        ? this.dataset.categories.split(",").filter((x) => x)
        : [];
      this.categorySelected =
        this.categories.length > 0 ? this.slugify(this.categories[0]) : "";
      this.btnNextEl = this.querySelector(".btn-next");
      this.btnEditEl = this.querySelector(".btn-edit");
      this.btnWriteEl = this.querySelector(".btn-write");
      this.btnDoneEl = this.querySelector(".btn-done");
      if (this.categories.length > 1) {
        this.initCategories();
      }
      this.updateSteps();
      this.updateDisplay();
      this.initEvents();
    }
    updateSteps() {
      this.btnNextEl.disabled = true;
      if (this.currentStep === this.messageStepEls.length - 1) {
        this.btnNextEl.classList.add("hide");
        this.btnDoneEl.classList.remove("hide");
      } else {
        this.btnNextEl.classList.remove("hide");
        this.btnDoneEl.classList.add("hide");
      }
      this.hideSteps();
      this.querySelector(
        `.message-step.message-step-${this.currentStep}.message-category-${this.categorySelected}`
      ).classList.add("active");
    }
    hideSteps() {
      this.messageStepEls.forEach((messageStepEl) =>
        messageStepEl.classList.remove("active")
      );
    }
    initCategories() {
      this.categories.forEach((category, indexCategory) => {
        let btnCategory = document.createElement("button");
        btnCategory.classList.add("btn", "btn-category");
        if (indexCategory === 0) btnCategory.classList.add("active");
        btnCategory.dataset.categoryId = this.slugify(category);
        btnCategory.innerHTML = category;
        this.querySelector(".message-categories").appendChild(btnCategory);
        btnCategory.addEventListener(
          "click",
          this.onCategorySelected.bind(this)
        );
      });
    }
    initEvents() {
      this.btnNextEl.addEventListener("click", this.onNextStep.bind(this));
      this.btnWriteEl.addEventListener("click", this.onWrite.bind(this));
      this.btnDoneEl.addEventListener("click", this.onDone.bind(this));
      this.btnEditEl.addEventListener("click", this.onEdit.bind(this));
      this.messageStepEls.forEach((messageStepEl) =>
        messageStepEl.addEventListener(
          "messageSelected",
          this.onMessageSelected.bind(this)
        )
      );
      if (this.progressBarEl) {
        this.progressBarEl.addEventListener(
          "stepSelected",
          this.onStepSelected.bind(this)
        );
      }
    }
    reset() {
      this.selectedMessages = [];
      this.currentStep = 0;
      this.messageStepEls.forEach((messageStepEl) =>
        messageStepEl.clearButtons()
      );
      this.updateDisplay();
      this.updateSteps();
    }
    updateDisplay() {
      var message = this.selectedMessages.join(" ");
      if (this.selectedMessages.length > 0) {
        this.messageDisplayEl.classList.add("personalized");
      } else {
        this.messageDisplayEl.classList.remove("personalized");
      }
      this.messageDisplayEl.innerHTML =
        this.selectedMessages.length > 0
          ? `"${
              this.preMessage ? `${this.preMessage.trim()}&nbsp;` : ``
            }${message}"`
          : this.defaultMessage;
      this.dispatchEvent(
        new CustomEvent("assistedMessageUpdated", { detail: { message } })
      );
    }
    onCategorySelected(event) {
      event.preventDefault();
      this.querySelectorAll(".btn-category").forEach((btnCategoryEl) =>
        btnCategoryEl.classList.remove("active")
      );
      event.target.classList.add("active");
      this.categorySelected = event.target.dataset.categoryId;
      this.reset();
      this.notifyUpdate();
      this.updateSteps();
    }
    onStepSelected(event) {
      this.selectedMessages = this.selectedMessages.splice(
        0,
        event.detail.stepId
      );
      this.currentStep = event.detail.stepId;
      for (var i = this.currentStep; i < this.messageStepEls.length - 1; i++) {
        this.messageStepEls[i].clearButtons();
      }
      this.updateDisplay();
      this.updateSteps();
      this.notifyUpdate();
    }
    onNextStep(event) {
      event.preventDefault();
      this.currentStep = this.currentStep + 1;
      this.updateSteps();
      this.notifyUpdate();
    }
    updateState() {
      if (this.editMode) {
        this.classList.add("editing");
        this.btnEditEl.classList.add("hide");
      } else {
        this.classList.remove("editing");
        this.btnEditEl.classList.remove("hide");
      }
    }
    onDone(event) {
      event.preventDefault();
      this.editMode = false;
      this.updateState();
    }
    onEdit(event) {
      event.preventDefault();
      this.editMode = true;
      this.updateState();
    }
    onWrite(event) {
      event.preventDefault();
      this.dispatchEvent(new CustomEvent("writeCustomMessage"));
    }
    notifyUpdate() {
      this.dispatchEvent(
        new CustomEvent("stepsUpdated", {
          detail: { stepId: this.currentStep },
        })
      );
    }
    onMessageSelected(event) {
      this.btnNextEl.disabled = false;
      this.selectedMessages[event.detail.stepId] = event.detail.message;
      this.updateDisplay();
    }
    slugify(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim leading/trailing white space
      str = str.toLowerCase(); // convert string to lowercase
      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove any non-alphanumeric characters
        .replace(/\s+/g, "-") // replace spaces with hyphens
        .replace(/-+/g, "-"); // remove consecutive hyphens
      return str;
    }
  }
  customElements.define("assisted-message", AssistedMessageComponent);
}

if (!customElements.get("message-step")) {
  class GiftCardMessageStep extends HTMLElement {
    constructor() {
      super();
      this.stepId = parseInt(this.dataset.stepId);
      this.messageBtnEls = this.querySelectorAll(".btn-message");
      this.initEvents();
    }
    initEvents() {
      this.messageBtnEls.forEach((messageBtnEl) =>
        messageBtnEl.addEventListener(
          "click",
          this.onMessageSelected.bind(this)
        )
      );
    }
    clearButtons() {
      this.messageBtnEls.forEach((messageBtnEl) =>
        messageBtnEl.classList.remove("selected")
      );
    }
    onMessageSelected(event) {
      event.preventDefault();
      this.clearButtons();
      event.target.classList.add("selected");
      this.dispatchEvent(
        new CustomEvent("messageSelected", {
          detail: {
            message: event.target.dataset.message,
            stepId: this.stepId,
          },
        })
      );
    }
  }
  customElements.define("message-step", GiftCardMessageStep);
}
